export function isTckApiUrl(url: string) {
  return url.includes('/api/ask/');
}
